import React from "react";

// Lazy-loaded import of the Category component using React.lazy
export const BookCategoryManagement = React.lazy(() => import("./Category/index.page"));
